import React from "react";
import ReactDOM from "react-dom";
import HierarchicalDataViewer from "./components/HierarchicalDataViewer";

const rootContainer = document.getElementById("root-container");

ReactDOM.render(
  <HierarchicalDataViewer
    hierarchyData={window.HIERARCHY_DATA}
    mergedData={window.MERGED_DATA}
    ontologyDictionary={window.ONTOLOGY}
    understandableLabelsDictionary={window.LABEL_TO_CLASS}
    acronymsData={window.ACRONYMS_DATA}
  />,
  rootContainer
);
